import store from '@/store/store';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';

class EstruturaController {
  public static async getHierarquiaOrganizacao(
    showLoading = true,
  ): Promise<any> {
    const route = 'getHierarquiaOrganizacao';

    const user: User = store.getters.user;
    const nrOrg = user.nrorg;
    const nrVinculo = user.nrvinculom;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const hierarquia: any = response.data.dataset.data;

    return hierarquia;
  };

  public static async getAniversariantesEstrutura(
    nrEstrutura: string,
    showLoading = true,
  ): Promise<any> {
    const route = 'getAniversariantesEstrutura';

    const user: User = store.getters.user;
    const nrOrg = user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESTRUTURAM: nrEstrutura,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const aniversariantes: any[] = response.data.dataset.data;

    return aniversariantes;
  };
}

export default EstruturaController;
